import BaseService from "@/shared/base.service";

import type { DashboardResponse } from "@/types/response/dashboard";

export class DashboardService {
  static async GetIntegrationDashboard(
    initial_datetime: string,
    final_datetime: string
  ): Promise<DashboardResponse | null> {
    try {
      const params = {
        initial_datetime,
        final_datetime,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<{ data: DashboardResponse }>(
        `integration_dashboard`,
        queryParams
      );

      return response?.data ?? null;
    } catch (error) {
      console.error("Error in GetIntegrationDashboard:", error);
      return null;
    }
  }
}
